import { Color, DefaultValue, getDefaultTransition, Spacing } from '@billy/design-system'
import { css } from '@emotion/core'
import styled from '@emotion/styled'

interface QuickStartAccordionWrapperProps {
  isOpen: boolean
}

interface QuickStartAccordionTriggerProps {
  isCompleted: boolean
}

interface QuickStartAccordionContentWrapperProps {
  isOpen: boolean
}

export const QuickStartAccordionWrapper = styled.div<QuickStartAccordionWrapperProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid ${({ isOpen }) => (isOpen ? Color.Black : Color.Grey100)};
  border-radius: ${DefaultValue.BorderRadius};
  background: ${Color.White};
  transition: ${getDefaultTransition('border-color')};
`

export const QuickStartAccordionTrigger = styled.button<QuickStartAccordionTriggerProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S16};
  width: 100%;
  height: 52px;
  padding: 0 ${Spacing.S16};
  border: none;
  background: none;
  text-align: left;
  cursor: ${({ isCompleted }) => (isCompleted ? 'default' : 'pointer')};
  user-select: none;
  transition: ${getDefaultTransition('opacity')};

  ${({ isCompleted }) =>
    !isCompleted &&
    css`
      &:hover {
        opacity: 0.8;
      }
    `}
`

export const QuickStartAccordionContentWrapper = styled.div<QuickStartAccordionContentWrapperProps>`
  display: grid;
  overflow: hidden;
  transition:
    grid-template-rows 0.5s cubic-bezier(0.25, 0.8, 0.25, 1),
    padding 0.4s ease-in-out,
    opacity 0.35s ease-in-out ${({ isOpen }) => (isOpen ? '0s' : '0.1s')};

  ${({ isOpen }) =>
    isOpen
      ? css`
          visibility: visible;
          opacity: 1;
          grid-template-rows: 1fr;
          padding: 0 ${Spacing.S16} ${Spacing.S16};
        `
      : css`
          visibility: hidden;
          opacity: 0;
          grid-template-rows: 0fr;
          padding: 0 ${Spacing.S16};
        `}
`

export const QuickStartAccordionContentInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.S12};
  min-height: 0;
  overflow: hidden;
`
